/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { O5AwsDeployerV1StackQueryServiceStackGetResponse, O5AwsDeployerV1StackQueryServiceStackGetStackGetRequest } from '@interxfi/types';

export const O5_AWS_DEPLOYER_V1_STACK_QUERY_SERVICE_STACK_GET_AUDIENCE = ['o5'];

export async function o5AwsDeployerV1StackQueryServiceStackGet(baseUrl: string | undefined, request?: O5AwsDeployerV1StackQueryServiceStackGetStackGetRequest, requestInit?: RequestInit): Promise<O5AwsDeployerV1StackQueryServiceStackGetResponse | undefined> { return makeRequest<O5AwsDeployerV1StackQueryServiceStackGetResponse, O5AwsDeployerV1StackQueryServiceStackGetStackGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/deployer/v1/stacks/q/:stackId', request, requestInit)); }

